// @flow

import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';

import { GoogleSSOButton } from './GoogleSSOButton';

import TrackData from 'app/track/Data';

import { type Dispatch } from 'app/common/types';

const SignupType = {
  oneTap: 'one-tap',
  googleOneTap: 'google-one-tap',
  sso: 'sso',
  googleSso: 'google-sso',
  direct: 'direct',
  facebookSso: 'facebook-sso',
  flab: 'flab-abs',
  flabSso: 'flab-sso',
  microsoftSso: 'microsoft-sso',
};

type OwnProps = {
  queryParams: {
    use_case_slug?: string,
  },
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => ({
  onClick: async (event, href) => {
    event.preventDefault();
    const useCaseSlug = ownProps.queryParams
      ? ownProps.queryParams.use_case_slug
      : '';

    try {
      await TrackData.trackSignupIntent(SignupType.sso, {
        useCaseSlug,
      });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch(routeTo(href));
    }
  },
});

export default connect(null, mapDispatchToProps)(GoogleSSOButton);
